document.addEventListener('DOMContentLoaded', () => {
  // Don't run on investments, using own custom menu. See investments tax-nav.js.
  if (document.getElementById('page').classList.contains('investments')) {
    return;
  }

  document.addEventListener('click', event => {
    // Grab all the li elements
    const list = document.querySelectorAll('ul#menu-primary > li');
    const primaryMenu = document.querySelectorAll('div.primaryNav--desktop')[0];
    for (let i = 0; i < list.length; i += 1) {
      if (event.target === list[i]) {
        if (event.target.classList.contains('inactive')) {
          list.forEach(node => {
            node.classList.remove('active');
            node.classList.add('inactive');
          });
          event.target.classList.add('active');
          event.target.classList.remove('inactive');
        } else {
          event.target.classList.add('inactive');
          event.target.classList.remove('active');
        }
      } else if (primaryMenu !== event.target) {
        list[i].classList.add('inactive');
        list[i].classList.remove('active');
      }
    }
  });
});

const docReady = fn => {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};
docReady(() => {
  let activeLinkInfo = null;

  function triggerResizeEvent() {
    const resizeEvent = new Event('resize');
    window.dispatchEvent(resizeEvent);
  }

  document.addEventListener('click', event => {
    const modalDivs = document.querySelectorAll('.top-nav--modal');
    const openModalDivs = document.querySelectorAll('.openModal');
    const arrows = document.querySelectorAll('.openModal svg');

    for (let i = 0; i < modalDivs.length; i += 1) {
      const modalDiv = modalDivs[i];
      const openModalDiv = openModalDivs[i];
      const arrow = arrows[i];

      if (event.target === openModalDiv) {
        if (window.getComputedStyle(modalDiv).display === 'none') {
          modalDiv.style.display = 'block'; // Change to 'block' to ensure it occupies space
          if (arrow) {
            arrow.style.transform = 'rotate(180deg)';
          }

          // Calculate and set the modal position under the container
          const containerRect = openModalDiv.getBoundingClientRect();
          modalDiv.style.left = `calc(${containerRect.left}px - 10px)`;
        } else {
          modalDiv.style.display = 'none';
          if (arrow) {
            arrow.style.transform = 'rotate(0deg)';
          }
        }
      } else {
        modalDiv.style.display = 'none';
        if (arrow) {
          arrow.style.transform = 'rotate(0deg)';
        }
      }

      const allLinks = modalDiv.querySelectorAll('a');

      if (event.target.tagName === 'A' && modalDiv.contains(event.target)) {
        const activeLinkText = event.target.textContent;
        const activeLinkHref = event.target.getAttribute('href');
        activeLinkInfo = {
          element: event.target,
          text: activeLinkText,
          href: activeLinkHref,
        };
      }

      allLinks.forEach(link => {
        link.classList.remove('active');
      });

      const currentBaseURL = window.location.origin;
      allLinks.forEach(link => {
        if (link.href.startsWith(currentBaseURL)) {
          link.classList.add('active');
        }
      });

      if (activeLinkInfo) {
        document.querySelector('.link').textContent = ` / ${activeLinkInfo.text}`;
      }
    }
    triggerResizeEvent();
  });
  window.addEventListener('resize', () => {
    const openModalDivs = document.querySelectorAll('.openModal');
    const modalDivs = document.querySelectorAll('.top-nav--modal');

    for (let i = 0; i < modalDivs.length; i += 1) {
      const modalDiv = modalDivs[i];
      const openModalDiv = openModalDivs[i];

      if (modalDiv.style.display === 'block' && openModalDiv) {
        const containerRect = openModalDiv.getBoundingClientRect();
        modalDiv.style.left = `calc(${containerRect.left}px - 10px)`;
      }
    }
  });

  document.querySelector('.top-nav--container--mobile').addEventListener('click', () => {
    const toggleButton = document.getElementById('primaryNav-toggle');
    if (toggleButton) {
      toggleButton.click();
    }
  });

  const topNav = document.querySelector('.top-nav--container');
  const siteHeader = document.querySelector('.site-header');
  const guidesHeader = document.querySelector('.guides-header');
  let siteHeaderStart = siteHeader.offsetTop;
  const siteHeaderTransparentHeight = siteHeader.classList.contains(
    'site-header--ventures-transparent',
  )
    ? siteHeader.offsetHeight
    : null;
  const mqFromTablet = window.matchMedia('(max-width: 1023px)');
  const bannerNotification = document.querySelector('.bannerNotification.banner-isSticky-true');

  const handleHeaderPosition = () => {
    const scrollPosition = window.scrollY;

    if (!mqFromTablet.matches) {
      if (scrollPosition >= siteHeaderStart) {
        siteHeader.style.top = `0px`;
        if (!siteHeader.classList.contains('fixed--withUtilityNav')) {
          siteHeader.classList.add('fixed--withUtilityNav');
        }

        if (bannerNotification) {
          bannerNotification.style.top = null;
        }
      } else if (siteHeaderTransparentHeight && scrollPosition === 0 && bannerNotification) {
        siteHeader.style.top = null;
        bannerNotification.style.top = null;
      } else {
        siteHeader.style.top = `${siteHeaderStart - scrollPosition}px`;
        if (siteHeader.classList.contains('fixed--withUtilityNav')) {
          siteHeader.classList.remove('fixed--withUtilityNav');
        }

        let siteHeaderHeight = siteHeader.offsetHeight;
        if (siteHeaderTransparentHeight) {
          siteHeaderHeight = siteHeaderTransparentHeight - 32;
        }

        if (bannerNotification) {
          bannerNotification.style.top = `${siteHeaderStart + siteHeaderHeight - scrollPosition}px`;
        }
      }
    }
  };

  if (topNav !== null) {
    handleHeaderPosition();

    window.addEventListener('scroll', handleHeaderPosition);

    window.addEventListener('resize', () => {
      if (mqFromTablet.matches) {
        siteHeader.style.top = null;
      } else {
        siteHeaderStart = topNav.offsetHeight;
        handleHeaderPosition();
      }
    });

    if (guidesHeader !== null) {
      const guidesHeaderStart = guidesHeader.offsetTop;
      const guidesNav = document.querySelector('.guides-navigation');
      const guidesNavStart = guidesNav.offsetTop;
      window.addEventListener('scroll', () => {
        const scrollPosition = window.scrollY ?? window.pageYOffset;

        if (!mqFromTablet.matches) {
          if (scrollPosition >= guidesHeaderStart) {
            guidesHeader.style.top = `0px`;
            guidesNav.style.top = `${guidesHeader.offsetHeight}px`;
            if (!guidesHeader.classList.contains('fixed--withUtilityNav')) {
              guidesHeader.classList.add('fixed--withUtilityNav');
            }
            if (!guidesNav.classList.contains('fixed--withUtilityNav')) {
              guidesNav.classList.add('fixed--withUtilityNav');
            }
          } else {
            guidesHeader.style.top = `${guidesHeaderStart - scrollPosition}px`;
            guidesNav.style.top = `${guidesNavStart - scrollPosition}px`;
            if (guidesHeader.classList.contains('fixed--withUtilityNav')) {
              guidesHeader.classList.remove('fixed--withUtilityNav');
            }
            if (guidesNav.classList.contains('fixed--withUtilityNav')) {
              guidesNav.classList.remove('fixed--withUtilityNav');
            }
          }
        }
      });

      window.addEventListener('resize', () => {
        if (mqFromTablet.matches) {
          guidesHeader.style.top = null;
          guidesNav.style.top = null;
        }
      });
    }
  }
});
